module.exports = __webpack_public_path__ + "img/not-found.1a6428a3.svg";